// extracted by mini-css-extract-plugin
export default {"contactListItem":"AccountsList_contactListItem__AW4k-","title":"AccountsList_title__lGh8b","label":"AccountsList_label__2Ysbc","buttons":"AccountsList_buttons__k7Qsu"};